import { cs } from "@/i18n/cs";

/**
 * Cena běhu session: primárně v procentech týdenního limitu (to je to, co
 * reálně dochází), tokeny jen jako fallback — u živých sessions jsou procenta
 * známá až po doběhnutí, u starších runnerů vůbec.
 */
export function sessionCostLabel(
  weekPctSpent: number | null,
  tokensTotal: number | null,
): string | null {
  if (weekPctSpent != null) {
    if (weekPctSpent < 0.1) return cs.workers.sessionCostTiny;
    return cs.workers.sessionCost(`${weekPctSpent.toFixed(1).replace(".", ",")} %`);
  }
  if (tokensTotal != null) return `${Math.round(tokensTotal / 1000)}k tokens`;
  return null;
}

/**
 * Kroky cyklu a průměrná velikost kontextu na krok — jediná dvojice, ze které
 * jde poznat, jestli session platila hodně práce, nebo mnohokrát totéž.
 * Cena se totiž neplatí za tokeny, ale za kroky: v každém se přečte celý
 * dosavadní kontext znovu.
 *
 * Baseline z 22.–23. 8. 2026 pro srovnání: **medián 63 kroků à 115k**.
 * Null u sessions ze starších runnerů, které kroky nehlásily.
 */
export function sessionStepsLabel(
  turns: number | null,
  avgContextTokens: number | null,
): string | null {
  if (turns == null) return null;
  const ctx = avgContextTokens != null ? ` à ${Math.round(avgContextTokens / 1000)}k` : "";
  return `${turns} ${cs.workers.steps}${ctx}`;
}

/** Relativní čas v češtině: „před 4 min", „před 2 h", „včera 16:40"… */
export function relativeTime(iso: string, now = new Date()): string {
  const date = new Date(iso);
  const diffMs = now.getTime() - date.getTime();
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return "teď";
  if (minutes < 60) return `před ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24 && date.getDate() === now.getDate()) return `před ${hours} h`;
  const time = date.toLocaleTimeString("cs-CZ", { hour: "2-digit", minute: "2-digit" });
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return `včera ${time}`;
  return `${date.toLocaleDateString("cs-CZ", { day: "numeric", month: "numeric" })} ${time}`;
}

export function clockTime(iso: string): string {
  return new Date(iso).toLocaleTimeString("cs-CZ", { hour: "2-digit", minute: "2-digit" });
}

/** Čas dopředu: „za 42 min", „za 3 h", jinak „18.8. 21:00". Minulost = „teď". */
export function untilTime(iso: string, now = new Date()): string {
  const date = new Date(iso);
  const minutes = Math.floor((date.getTime() - now.getTime()) / 60_000);
  if (minutes < 1) return "teď";
  if (minutes < 60) return `za ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24 && date.getDate() === now.getDate()) return `za ${hours} h`;
  const time = date.toLocaleTimeString("cs-CZ", { hour: "2-digit", minute: "2-digit" });
  return `${date.toLocaleDateString("cs-CZ", { day: "numeric", month: "numeric" })} ${time}`;
}
